import { types } from '../types/types';

const initialState = {
  interestsP: [],
  totalPagesP: 0,
  totalItemsP: 0,
  currentPageP: 0,
  selectedInterest: null,
  selectedOrigins: [],
  selectedTarget: null,
  loading: false,
};

export const userInterestReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_INTEREST_START_LOADING_PAGINATED:
      return {
        ...state,
        interestsP: action.payload.interestsP || [],
        totalItemsP: action.payload.totalItems || 0,
        totalPagesP: action.payload.totalPages || 0,
        currentPageP: action.payload.currentPage || 0,
        loading: false,
      };
    case types.USER_INTEREST_SELECT:
      return {
        ...state,
        selectedInterest: action.payload.interest || null,
        selectedOrigins: action.payload.origins || [],
        selectedTarget: action.payload.target || null,
        loading: false,
      };
    case types.USER_INTEREST_CLEAN:
      return {
        ...state,
        selectedInterest: null,
        selectedOrigins: [],
        selectedTarget: null,
      };
    case types.USER_INTEREST_SET_LOADING:
      return {
        ...state,
        loading: !!action.payload,
      };
    default:
      return state;
  }
};
